import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism";

export default function MarkdownRenderer({ children = "" }) {
  return (
    <div className="ecovanta-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          code({ inline, className, children, ...props }) {
            const match = /language-(\w+)/.exec(className || "");

            if (!inline && match) {
              return (
                <SyntaxHighlighter
                  style={oneLight}
                  language={match[1]}
                  PreTag="div"
                  customStyle={{
                    borderRadius: 10,
                    padding: 16,
                    fontSize: 14,
                    margin: "16px 0",
                  }}
                  {...props}
                >
                  {String(children).replace(/\n$/, "")}
                </SyntaxHighlighter>
              );
            }

            return (
              <code
                className={className}
                style={{
                  background: "#f3f4f6",
                  padding: "2px 6px",
                  borderRadius: 4,
                  fontSize: "0.95em",
                }}
                {...props}
              >
                {children}
              </code>
            );
          },

          table({ children }) {
            return (
              <div style={{ overflowX: "auto", margin: "16px 0" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                  }}
                >
                  {children}
                </table>
              </div>
            );
          },

          th({ children }) {
            return (
              <th
                style={{
                  border: "1px solid #ddd",
                  background: "#f7f7f7",
                  padding: 10,
                  textAlign: "left",
                }}
              >
                {children}
              </th>
            );
          },

          td({ children }) {
            return (
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: 10,
                }}
              >
                {children}
              </td>
            );
          },

          blockquote({ children }) {
            return (
              <blockquote
                style={{
                  borderLeft: "4px solid #0f766e",
                  margin: "16px 0",
                  paddingLeft: 16,
                  color: "#555",
                }}
              >
                {children}
              </blockquote>
            );
          },

          a({ href, children }) {
            return (
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#0f766e",
                  textDecoration: "none",
                }}
              >
                {children}
              </a>
            );
          },
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}